import { Text } from '@/components/ui/text'
import { Messages, Send } from '@components'
import { useAuth } from '@stateApp'
import { Lock } from 'lucide-solid'
import { type Component, Show } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Center, Grid } from 'styled-system/jsx'
import { useChannel } from './state'

export const Chat: Component<{
  height?: any
  setIsReadOnly?: boolean
  isMinimal?: boolean
}> = (props) => {
  // Notice how many unused imports and services we get to delete!
  const { activeChannelId, isReadOnly } = useService(useChannel)()
  const { isAdmin, isCommander } = useService(useAuth)()

  const canPostMessages = () => {
    if (props.setIsReadOnly === true) return false
    return !isReadOnly() || isAdmin() || isCommander()
  }

  return (
    <Show when={activeChannelId()}>
      <Grid
        class={css({
          gridTemplateRows: '1fr auto',
          transition: 'grid-template-rows 0.3s cubic-bezier(0.47, 0, 0.75, 0.72)',
          height: props.height,
          minHeight: 0,
          gap: 0,
          position: 'relative',
        })}
      >
        <Messages isMinimal={props.isMinimal} />
        <Show
          when={canPostMessages()}
          fallback={
            <Center position="absolute" bottom={0} width="100%" left="0" gap="1" p="1" borderTop="solid 1px" borderColor="bg.subtle">
              <Lock size="12" stroke="var(--colors-fg-subtle)" />
              <Text color="fg.subtle" textStyle="xs">Only Francis, Admin and Top Guns can post here</Text>
            </Center>
          }
        >
          <Send currentChannelId={activeChannelId()} />
        </Show>
      </Grid>
    </Show>
  )
}
